
export const LOAD_TEMPLATE = (state) => {
    return {
        ...state,
        loading: true
    };
};

export const LOAD_TEMPLATE_SUCCESS = (state, action) => {
    return {
        ...state,
        loading: false,
        list: action.payload
    };
};

export const LOAD_TEMPLATE_FAIL = (state) => {
    return {
        ...state,
        loading: false
    };
};

export const CREATE_TEMPLATE = (state) => {
    return {
        ...state,
        loading: true
    };
};

export const CREATE_TEMPLATE_SUCCESS = (state, action) => {
    return {
        ...state,
        loading: false,
        list: [action.payload, ...state.list]
    };
};

export const CREATE_TEMPLATE_FAIL = (state) => {
    return {
        ...state,
        loading: false
    };
};

export const GET_TEMPLATE = (state) => {
    return {
        ...state,
        loading: true
    };
};

export const GET_TEMPLATE_SUCCESS = (state, action) => {
    return {
        ...state,
        loading: false,
        current: action.payload
    };
};

export const GET_TEMPLATE_FAIL = (state) => {
    return {
        ...state,
        loading: false
    };
};

export const UPDATE_TEMPLATE = (state) => {
    return {
        ...state,
        loading: true
    };
};

export const UPDATE_TEMPLATE_SUCCESS = (state, action) => {
    const updatedTemplate = action.payload;
    return {
        ...state,
        loading: false,
        list: state.list.map(t => t._id === updatedTemplate._id ? updatedTemplate : t)
    };
};

export const UPDATE_TEMPLATE_FAIL = (state) => {
    return {
        ...state,
        loading: false
    };
};
